import { icons } from "../../../statics/icons";
import { UserRoles } from "../../../types/userRoles";

export const sideMenuItems: any[] = [
  // Dashboard
  {
    name: "",
    components: [
      {
        path: "/dashboard",
        pageTitle: "dashboard",
        name: "SIDE_MENU.DASHBOARD",
        icon: icons.PAGES.SIDE_NAVE.DASHBOARD_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.DASHBOARD,
        type: "component",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
          UserRoles.SUPER_USER,
        ],
      },
    ],
  },
  // AI Governance Platform
  {
    name: "SIDE_MENU.AI_GOVERNANCE_PLATFORM",
    components: [
      // {
      //   path: "/landscape",
      //   pageTitle: "landscape",
      //   name: "SIDE_MENU.AI_RISK_LANDSCAPE",
      //   icon: icons.PAGES.SIDE_NAVE.LANDSCAPE_LIGHT,
      //   activeIcon: icons.PAGES.SIDE_NAVE.LANDSCAPE,
      //   type: "component",
      //   roles: [
      //     UserRoles.SUPER_ADMIN,
      //     UserRoles.COORDINATOR,
      //     UserRoles.EDITOR,
      //     UserRoles.AUDITOR,
      //     UserRoles.CONTRIBUTOR,
      //     UserRoles.SUPER_USER,
      //   ],
      // },
      {
        path: "/ai-products",
        pageTitle: "products",
        name: "SIDE_MENU.AI_PRODUCTS",
        icon: icons.PAGES.SIDE_NAVE.AI_SOFTWARE_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.AI_SOFTWARE,
        type: "component",
        roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      },
      {
        path: "/ai-use-cases",
        pageTitle: "AI-UseCases",
        name: "SIDE_MENU.AI_USE_CASES",
        icon: icons.PAGES.SIDE_NAVE.AI_USE_CASES_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.AI_USE_CASES,
        type: "component",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
        ],
      },
      // {
      //   path: "/ai-software-development",
      //   pageTitle: "AI-Products",
      //   name: "SIDE_MENU.AI_SOFTWARE_DEVELOPMENT",
      //   icon: icons.PAGES.SIDE_NAVE.AI_SOFTWARE_LIGHT,
      //   activeIcon: icons.PAGES.SIDE_NAVE.AI_SOFTWARE,
      //   type: "component",
      //   roles: [
      //     UserRoles.SUPER_ADMIN,
      //     UserRoles.COORDINATOR,
      //     UserRoles.EDITOR,
      //     UserRoles.CONTRIBUTOR,
      //     UserRoles.AUDITOR,
      //   ],
      // },

      {
        path: "/ai-demand",
        pageTitle: "AI-Demand",
        name: "SIDE_MENU.AI_DEMAND_MANAGEMENT",
        icon: icons.PAGES.SIDE_NAVE.AI_DEMAND_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.AI_DEMAND,
        type: "component",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
        ],
      },
      {
        path: "/education",
        pageTitle: "Education",
        name: "SIDE_MENU.EDUCATION",
        icon: icons.PAGES.SIDE_NAVE.EDUCATION_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.EDUCATION,
        type: "component",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
        ],
      },
      // {
      //   name: "SIDE_MENU.SETTINGS",
      //   icon: icons.PAGES.SIDE_NAVE.SETTINGS_LIGHT,
      //   activeIcon: icons.PAGES.SIDE_NAVE.SETTINGS,
      //   path: "/settings",
      //   roles: [
      //     UserRoles.SUPER_ADMIN,
      //     UserRoles.COORDINATOR,
      //     UserRoles.EDITOR,
      //     UserRoles.AUDITOR,
      //     UserRoles.CONTRIBUTOR,
      //     UserRoles.SUPER_USER,
      //   ],
      //   children: [
      //     {
      //       path: "/settings/profile",
      //       name: "SIDE_MENU.SETTINGS_LIST.PROFILE",
      //       type: "component",
      //       roles: [
      //         UserRoles.SUPER_ADMIN,
      //         UserRoles.COORDINATOR,
      //         UserRoles.EDITOR,
      //         UserRoles.AUDITOR,
      //         UserRoles.CONTRIBUTOR,
      //         UserRoles.SUPER_USER,
      //       ],
      //     },
      //     {
      //       path: "/settings/workspace-management",
      //       name: "SIDE_MENU.SETTINGS_LIST.WORKSPACE",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      //     },
      //     {
      //       path: "/settings/data-exchange",
      //       name: "SIDE_MENU.SETTINGS_LIST.DATA_EXCHANGE",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      //     },
      //     {
      //       path: "/settings/role-management",
      //       name: "SIDE_MENU.SETTINGS_LIST.ROLE_MANAGEMENT",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN],
      //     },
      //     {
      //       path: "/settings/risk-level-management",
      //       name: "SIDE_MENU.SETTINGS_LIST.RISK_LEVEL_MANAGEMENT",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      //     },
      //     {
      //       path: "/settings/questions-builder",
      //       name: "SIDE_MENU.SETTINGS_LIST.QUESTIONS_BUILDER",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      //     },
      //     {
      //       path: "/settings/database-value-management",
      //       name: "SIDE_MENU.SETTINGS_LIST.DATABASE_VALUE_MANAGEMENT",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      //     },
      //     {
      //       path: "/settings/branch-management",
      //       name: "SIDE_MENU.SETTINGS_LIST.BRANCH_MANAGEMENT",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      //     },
      //     {
      //       path: "/settings/activity-log",
      //       name: "SIDE_MENU.SETTINGS_LIST.ACTIVITY_LOG",
      //       type: "component",
      //       roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      //     },
      //   ],
      // },
      {
        path: "/user-management",
        pageTitle: "SIDE_MENU.USER_MANAGEMENT",
        name: "SIDE_MENU.USER_MANAGEMENT",
        icon: icons.PAGES.SIDE_NAVE.USER_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.USER,
        type: "component",
        roles: [UserRoles.SUPER_ADMIN, UserRoles.COORDINATOR],
      },
    ],
  },
  // Task Management
  {
    name: "SIDE_MENU.TASK_MANAGEMENT",
    components: [
      {
        path: "/ai-tasks",
        pageTitle: "AI-Tasks",
        name: "SIDE_MENU.AI_TASKS",
        icon: icons.PAGES.SIDE_NAVE.AI_TASKS_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.AI_TASKS,
        type: "component",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
        ],
      },
    ],
  },
  // Pages
  {
    name: "SIDE_MENU.PAGRS",
    components: [
      {
        path: "https://paiper.one/",
        pageTitle: "company",
        name: "SIDE_MENU.COMPANY",
        icon: icons.PAGES.SIDE_NAVE.COMPANY_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.COMPANY,
        type: "link",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
          UserRoles.SUPER_USER,
        ],
      },
      {
        path: "https://paiper.one/ai-news/",
        pageTitle: "blog",
        name: "SIDE_MENU.BLOG",
        icon: icons.PAGES.SIDE_NAVE.BLOG_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.BLOG,
        type: "link",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
          UserRoles.SUPER_USER,
        ],
      },
    ],
  },
  // Apps
  {
    name: "SIDE_MENU.APPS",
    components: [
      {
        path: "https://ai-community.paiper.one",
        pageTitle: "AI-Community",
        name: "SIDE_MENU.AI_COMMUNITY",
        icon: icons.PAGES.SIDE_NAVE.COMMUNITY_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.COMMUNITY,
        type: "link",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
          UserRoles.SUPER_USER,
        ],
      },
      {
        path: "https://paiper.one/ai-risk-assesment/",
        pageTitle: "AI-assistant",
        name: "SIDE_MENU.AI_ASSISTANT",
        icon: icons.PAGES.SIDE_NAVE.ASSISTENT_LIGHT,
        activeIcon: icons.PAGES.SIDE_NAVE.ASSISTENT,
        type: "link",
        roles: [
          UserRoles.SUPER_ADMIN,
          UserRoles.COORDINATOR,
          UserRoles.EDITOR,
          UserRoles.AUDITOR,
          UserRoles.CONTRIBUTOR,
        ],
      },
    ],
  },
];
